<template>
  <v-dialog
    v-model="enable"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-container>
        <v-card-title class="headline px-0">
          Edit Account
        </v-card-title>
        <v-card-text class="px-2">
          <v-form
            id="form_register"
            ref="form"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <v-text-field
                ref="acc_name"
                v-model="req.name"
                append-icon="mdi-account-box"
                name="account_Name"
                :rules="accountNameRules"
                label="Account Name*"
                type="text"
                autofocus
                required
                :error-messages="getError('Name')"
                @mouseup="dirtyError('Name')"
              />
            </v-flex>
            <v-flex>
              <v-checkbox
                v-model="req.excludeOnlineOrderTax"
                dense
                label="Exclude Online Aggregator Order Tax"
                :hint="taxExcludeHint"
                persistent-hint
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight: 400; margin-right: 4px">
              *indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            id="register_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            id="register_save"
            color="success"
            class="white--text"
            :disabled="!isValid"
            :loading="loader"
            @click.native="editAccount()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditAccount",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    accountId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isValid: false,
      loader: false,
      req: {
        name: ""
      },
      errors: {},
      accountNameRules: [
        (v) => !!v || "Account name is required",
        (v) =>
          (v && v.length <= 50) ||
          "AccountName must be less than 50 characters"
      ],
      taxExcludeHint: "Taxes will be recorded, but it will be excluded from the reports."
    };
  },
  computed: {
    enable: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("update:showDialog", val);
        console.log({ val });
      }
    }
  },
  watch: {
    enable: {
      handler: function(v){
        if (v) {
          if (v) {
            this.getAccount();
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit("update:showDialog", false);
      this.$emit("refresh");
      this.clear();
    },
    getAccount() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/accounts/${this.accountId}`;
      this.$http.get(url).then(
        function (res) {
          this.loader = false;
          this.req = {
            name: res.body.name,
            excludeOnlineOrderTax: res.body.excludeOnlineOrderTax
          };
        },
        function (failure) {
          this.handleFailure(failure);
        }
      );
    },
    editAccount: function () {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loader = true;
      this.req.accountId = this.accountId;
      this.$http
        .put(`${this.ADMIN_API_URL}/accounts/${this.accountId}`, this.req)
        .then(
          function (data) {
            this.loader = false;
            this.close();
            this.$store.commit("showSnackbar", {
              timeout: 3000,
              message: data.body.message
            });
          },
          function (failure) {
            this.loader = false;
            this.handleFailure(failure);
          }
        );
    },
    getError(key) {
      return this.errors && this.errors[key] ? [this.errors[key]] : [];
    },
    dirtyError(key) {
      this.errors[key] = "";
    },
    handleFailure: function (failure) {
      let msg = failure.body.message || "Error";
      let errors = failure.body.errors;
      if (errors && errors.Name) {
        msg = errors.Name;
      }
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    },
    clear() {
      this.errors = {};
      this.$refs.form.reset();
    }
  }
};
</script>